<template>
  <v-app>
    <router-view :key="$route.fullPath"></router-view>
  </v-app>
</template>
<script>
export default {
  data() {
    return {};
  },
  mounted() {
    //console.log(document.cookie);
    if (!document.cookie.match(/secure-vote/)) {
      //this.$router.replace({ path: '/no-cookies' });
      //console.log('Unable to find cookie');
      //console.log(document.cookie);
    }
    //console.log(document.cookie);
    // Check for cookies allowed
    /*
    try {
      localStorage.setItem(
        'TAjYWQB2yedPHE0PGQ7UVHPgTJmcgo5h',
        'TAjYWQB2yedPHE0PGQ7UVHPgTJmcgo5h'
      );
      localStorage.removeItem('TAjYWQB2yedPHE0PGQ7UVHPgTJmcgo5h');
    } catch (err) {
      console.log(err);
      this.$router.replace({ path: '/no-cookies' });
    }
    */
  }
};
</script>
